import { WarningOutlined } from '@vindr/icons';
import classNames from 'classnames';
import Header from './Header';

type ErrorPageInterface = {
  className?: string;
  icon?: React.ReactNode;
  showHeader?: boolean;
  textBlock?: React.ReactNode;
  children?: React.ReactNode;
  childrenHeader?: React.ReactNode;
};

const ErrorPage = ({
  className = '',
  textBlock,
  children,
  childrenHeader,
  icon = null,
  showHeader = true,
}: ErrorPageInterface): JSX.Element => {
  return (
    <div className={classNames(`flex h-screen w-screen flex-col`, className)}>
      {showHeader && (
        <Header
          isReturnEnabled
          onClickReturnButton={() => window.history.back()}
        >
          {childrenHeader}
        </Header>
      )}
      <div className="mx-auto flex h-full w-full flex-col items-center justify-center space-y-2 bg-background-light-3 py-8 px-8 text-white drop-shadow-md dark:bg-background-dark-3">
        <div className="mb-2 space-y-2 pt-4 text-center">
          {icon ? icon : <WarningOutlined className="text-6xl text-white" />}
        </div>
        {textBlock || children}
      </div>
    </div>
  );
};

export default ErrorPage;
